module.exports = __webpack_public_path__ + "img/Group 16.ecdfeb51.png";